import '../../App.css';
import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { FaTimes, FaPlus } from 'react-icons/fa';
import { TbTrash } from 'react-icons/tb';
import { SlOptionsVertical } from 'react-icons/sl';
import { Form, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';
import ModalObterServico from './ModalObterServico';

function ModalEditarCapacidade({ currentPage }) {

    const { setModalEditar, DemandaAtual, EditarCapacidade, ListaCapacidades, Capacidades, SistemaCapacidade, EdicaoCapacidade, setEdicaoCapacidade, AreaCapacidade, ListaAreaCapacidade, Pessoas, ListaPessoa, AdicionarServicoCapacidade, ListaServicoCapacidade, ExcluirServicoCapacidade, CapacidadeServico, RetornaSistemaCapacidade, CapacidadeSistema, RetornaTipoCapacidade, TipoCapacidade, setLoading, ListaDominioMapaCalor, DominioMapaCalor } = useContext(ApiContext)
    const { ListaServico, Servicos, setError, setServicoAtualKey, ObterServico } = useContext(ServicoContext)
    const { btnVer, btnCriar, h3Demanda } = useContext(StyleContext)
    const [KeyPai, setKeyPai] = useState(EdicaoCapacidade?.capacidadeNegocioDemandaPai !== null ? EdicaoCapacidade?.capacidadeNegocioDemandaPai?.key : "")
    const [areaKey, setAreaKey] = useState(EdicaoCapacidade?.area !== null ? EdicaoCapacidade?.area.key : "")
    const [arquitetoKey, setArquitetoKey] = useState(EdicaoCapacidade?.arquiteto !== null ? EdicaoCapacidade?.arquiteto.key : "")
    const [pessoaKey, setPessoaKey] = useState(EdicaoCapacidade?.pessoa !== null ? EdicaoCapacidade?.pessoa.key : "")
    const [servicoKey, setServicoKey] = useState("")
    const servicoRef = useRef()
    const [modalEditarServico, setModalEditarServico] = useState(false)
    const [dominio, setDominio] = useState(EdicaoCapacidade?.dominio)
    const [dominioKey, setDominioKey] = useState(EdicaoCapacidade?.dominioCapacidadeMapaCalor !== null ? EdicaoCapacidade?.dominioCapacidadeMapaCalor?.key : "")

    const lightenColor = (color, percent) => {
        const num = parseInt(color.replace("#", ""), 16);
        const amt = Math.round(2.55 * percent);
        const R = (num >> 16) + amt;
        const G = ((num >> 8) & 0x00ff) + amt;
        const B = (num & 0x0000ff) + amt;
        return (
            "#" +
            (
                0x1000000 +
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            )
                .toString(16)
                .slice(1)
        );
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updated = { ...EdicaoCapacidade, [name]: value };

        if (name === "dominioCapacidadeMapaCalorKey") {
            const dominio = DominioMapaCalor?.find(d => d.key === value);
            if (dominio?.corHexadecimal) {
                updated.corHexadecimal = lightenColor(dominio.corHexadecimal, 50);
            }
        }

        setEdicaoCapacidade(updated);
    }

    const handleChangeCheckbox = (event) => {
        setEdicaoCapacidade({ ...EdicaoCapacidade, [event.target.name]: event.target.checked })
    }

    const editarItensDemanda = (e) => {
        setLoading(true);
        if (e) e.preventDefault();
        EditarCapacidade(DemandaAtual.key, KeyPai, areaKey, pessoaKey, arquitetoKey, currentPage, dominio, dominioKey)
            .then(() => {
                setLoading(false);
                setModalEditar(false)
            })
            .catch((error) => {
                console.log(error)
                setLoading(false);
            })
    }

    useEffect(() => {
        ListaPessoa()
        ListaAreaCapacidade()
        ListaServico()
        ListaServicoCapacidade()
        RetornaSistemaCapacidade()
        ListaCapacidades('S')
        RetornaTipoCapacidade()
        ListaDominioMapaCalor()
    }, [])

    const adicionarServico = () => {
        if (!servicoKey || servicoKey === "0") {
            setError("Selecione um serviço.");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        AdicionarServicoCapacidade(servicoKey)
            .then(() => {
                setServicoKey("");
                servicoRef.current.value = 0;
            });
    };

    const abrirModalServico = (servicoKey) => {
        setModalEditarServico(true)
        setServicoAtualKey(servicoKey)
        ObterServico(servicoKey)
    }

    useEffect(() => {
        if (CapacidadeServico && CapacidadeServico.length > 0) {
            const servicosSelecionados = CapacidadeServico.map(item => ({
                servicoKey: item.servico.key,
                capacidadeNegocioDemandaKey: item.capacidadeNegocioDemanda.key
            }));
            setEdicaoCapacidade(prev => ({
                ...prev,
                servicos: servicosSelecionados
            }));
        } else {
            setEdicaoCapacidade(prev => ({ ...prev, servicos: [] }));
        }
    }, [CapacidadeServico]);

    return (
        <>
            {modalEditarServico &&
                <ModalObterServico setModalEditarServico={setModalEditarServico} />
            }
            <div className="modal-novo">
                <div className="modal-novo-interno">
                    <div className="header-modal">
                        <div>
                            <h1 className="h1-modal">Editar cadastro</h1>
                        </div>
                        <div className="btn-close-modal" onClick={() => setModalEditar(false)}>
                            <FaTimes />
                        </div>
                    </div>
                    <div className="modal-content">
                        <form className="mb-3">
                            <Tabs className='mt-3 mb-3'>
                                <Tab eventKey="capacidades" title={<span>Capacidade</span>}>
                                    <Row>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Título</Form.Label>
                                            <Form.Control maxLength={100} defaultValue={EdicaoCapacidade.titulo} onChange={handleChange} name="titulo" />
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Col xs={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nível</Form.Label>
                                                <Form.Control maxLength={100} defaultValue={EdicaoCapacidade.nivel} onChange={handleChange} name="nivel" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Capacidade de Negócio Pai</Form.Label>
                                                <Form.Select aria-label="Default select example" onChange={(e) => setKeyPai(e.target.value)} name="capacidadeNegocioDemandaPaiId">
                                                    <option key={0} value="0">Selecione</option>
                                                    {Capacidades && Capacidades
                                                        .slice()
                                                        .sort((a, b) => {
                                                            if (a?.nivel && b?.nivel) {
                                                                return a?.nivel - b?.nivel;
                                                            }
                                                            if (a?.nivel && !b?.nivel) {
                                                                return -1;
                                                            }
                                                            if (!a?.nivel && b?.nivel) {
                                                                return 1;
                                                            }
                                                            return a?.titulo?.localeCompare(b?.titulo);
                                                        })
                                                        .map((item) => {
                                                            return (
                                                                <option key={item.id} value={item.key} selected={item.key == EdicaoCapacidade?.capacidadeNegocioDemandaPai?.key ? true : false}>
                                                                    {item.nivel ? `${item.nivel} -` : ""} {item.titulo}
                                                                </option>
                                                            )
                                                        })}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={5}>
                                            <Form.Label>Área</Form.Label>
                                            <Form.Select onChange={(e) => setAreaKey(e.target.value)} name="areaKey">
                                                <option value="0">Selecione</option>
                                                {AreaCapacidade &&
                                                    AreaCapacidade?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key} selected={EdicaoCapacidade.area !== null && item.key == EdicaoCapacidade.area.key ? true : false}>
                                                                {item.descricao}
                                                            </option>
                                                        )
                                                    })}
                                            </Form.Select>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control as="textarea" rows={3} maxLength={2000} onChange={handleChange} defaultValue={EdicaoCapacidade?.descricao} name="descricao" />
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Label>Business Owner</Form.Label>
                                            <Form.Select onChange={(e) => setPessoaKey(e.target.value)} name="pessoaKey">
                                                <option value="0">Selecione</option>
                                                {Pessoas &&
                                                    Pessoas?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key} selected={EdicaoCapacidade?.pessoa !== null && item.key == EdicaoCapacidade?.pessoa.key ? true : false}>
                                                                {item.nome}
                                                            </option>
                                                        )
                                                    })}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <Form.Label>Arquiteto corporativo</Form.Label>
                                            <Form.Select onChange={(e) => setArquitetoKey(e.target.value)} name="arquitetoKey">
                                                <option value="0">Selecione</option>
                                                {Pessoas &&
                                                    Pessoas?.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.key} selected={EdicaoCapacidade?.arquiteto !== null && item.key == EdicaoCapacidade?.arquiteto.key ? true : false}>
                                                                {item.nome}
                                                            </option>
                                                        )
                                                    })}
                                            </Form.Select>
                                        </Col>
                                        <Col>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Relevância</Form.Label>
                                                <Form.Select aria-label="Default select example" value={EdicaoCapacidade.relevancia} onChange={handleChange} name="relevancia">
                                                    <option value="">Selecione</option>
                                                    <option value="Habilitação de negócios">Habilitação de negócios</option>
                                                    <option value="Evolução de Negócios">Evolução de Negócios</option>
                                                    <option value="Operação de negócios">Operação de negócios</option>
                                                    <option value="Missão crítica">Missão crítica</option>
                                                    <option value="Desconhecido">Desconhecido</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab eventKey="sistemas" title={<span>Aplicações</span>}>
                                    <h3 className='h3-demanda' style={h3Demanda}>Aplicações vinculadas</h3>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Aplicação</th>
                                                <th>Fornecedor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {CapacidadeSistema && CapacidadeSistema.length > 0 ? (
                                                CapacidadeSistema.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item?.nome}</td>
                                                        <td>{item?.fornecedor?.fantasia}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="2">Nenhuma capacidade disponível</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </Tab>
                                <Tab eventKey="servicos" title={<span>Serviços</span>}>
                                    <h1 className='h1-modal'>Serviços</h1>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '25px' }}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Select ref={servicoRef} aria-label="Default select example" onChange={(e) => setServicoKey(e.target.value)}>
                                                    <option value={0}>Selecione</option>
                                                    {Servicos &&
                                                        Servicos?.map((c) => {
                                                            return (
                                                                <option key={c.id} value={c.key}>{c.descricao}</option>
                                                            )

                                                        })}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <button type="button" className="btn-dash btn-criar btn-add" style={btnCriar} onClick={() => adicionarServico()}><FaPlus /></button>
                                    </div>
                                    <hr />
                                    <Row>
                                        <div style={{ height: '30vh', width: '100%', overflow: 'auto' }}>
                                            {CapacidadeServico && CapacidadeServico.map((item, index) => {
                                                return (
                                                    <div key={index}>
                                                        <div key={index} className="content-comentario">
                                                            <div className="div-comentario">
                                                                <SlOptionsVertical style={{ marginRight: '15px' }} className='span-bsc' />
                                                                <button className='span-bsc' type='button' style={{ border: 'none', backgroundColor: 'transparent' }} onClick={() => abrirModalServico(item.servico.key)} >{item.servico.descricao}</button>
                                                            </div>
                                                            <div className="div-button">
                                                                <button type="button" className="btn-del" onClick={() => ExcluirServicoCapacidade(item.key)}><TbTrash /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Row>
                                </Tab>
                                <Tab eventKey="mapacalor" title={<span>Mapa de Calor</span>}>
                                    <Row>
                                        <Col xs={6}>
                                            {['checkbox'].map((type) => (
                                                <div>
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`default-${type}`}
                                                        label="Domínio"
                                                        name="dominio"
                                                        checked={dominio}
                                                        onChange={(e) => setDominio(e.target.checked)}
                                                    />
                                                </div>
                                            ))}
                                        </Col>
                                    </Row>
                                    {dominio && (
                                        <Row>
                                            <Col xs={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Domínio da Capacidade</Form.Label>
                                                    <Form.Select
                                                        value={dominioKey || "0"}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setDominioKey(value);

                                                            // Busca o domínio selecionado
                                                            const dominioSelecionado = DominioMapaCalor?.find(d => d.key === value);

                                                            if (dominioSelecionado?.corHexadecimal) {
                                                                // Gera a cor mais clara (simulando opacidade 0.5)
                                                                const corClara = lightenColor(dominioSelecionado.corHexadecimal, 50);

                                                                // Atualiza o estado da capacidade de edição
                                                                setEdicaoCapacidade(prev => ({
                                                                    ...prev,
                                                                    dominioCapacidadeMapaCalorKey: value,
                                                                    corHexadecimal: corClara
                                                                }));
                                                            } else {
                                                                // Caso não haja cor definida, apenas atualiza a key
                                                                setEdicaoCapacidade(prev => ({
                                                                    ...prev,
                                                                    dominioCapacidadeMapaCalorKey: value
                                                                }));
                                                            }
                                                        }}
                                                        name="dominioCapacidadeMapaCalorKey"
                                                    >
                                                        <option value="0">Selecione</option>
                                                        {DominioMapaCalor &&
                                                            DominioMapaCalor.map((item) => (
                                                                <option
                                                                    key={item.id}
                                                                    value={item.key}
                                                                    selected={
                                                                        EdicaoCapacidade?.dominioCapacidadeMapaCalor?.key !== null &&
                                                                        item.key == EdicaoCapacidade?.dominioCapacidadeMapaCalor?.key
                                                                    }
                                                                >
                                                                    {item.descricao}
                                                                </option>
                                                            ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={1}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Cor</Form.Label>
                                                    <Form.Control
                                                        type="color"
                                                        name="corHexadecimal"
                                                        value={EdicaoCapacidade?.corHexadecimal || "#ffffff"}
                                                        onChange={(e) =>
                                                            setEdicaoCapacidade((prev) => ({
                                                                ...prev,
                                                                corHexadecimal: e.target.value
                                                            }))
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    )}
                                    {!dominio &&
                                        <>
                                            <Row>
                                                <Col xs={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Tipo da Capacidade</Form.Label>
                                                        <Form.Select value={EdicaoCapacidade.tipoCapacidade} onChange={handleChange} name="tipoCapacidade">
                                                            <option value="0">Selecione</option>
                                                            {TipoCapacidade &&
                                                                TipoCapacidade?.map((item) => {
                                                                    return (
                                                                        <option key={item.id} value={item.id}>{item.descricao}</option>
                                                                    )
                                                                })

                                                            }
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {['checkbox'].map((type) => (
                                                    <div key={`inline-${type}`} className="mb-3">
                                                        <Form.Check
                                                            inline
                                                            label="Rodar"
                                                            name="rodar"
                                                            type={type}
                                                            id={`inline-${type}-1`}
                                                            checked={EdicaoCapacidade.rodar}
                                                            onChange={handleChangeCheckbox}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Crescer"
                                                            name="crescer"
                                                            type={type}
                                                            id={`inline-${type}-2`}
                                                            checked={EdicaoCapacidade.crescer}
                                                            onChange={handleChangeCheckbox}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Transformar"
                                                            name="transformar"
                                                            type={type}
                                                            id={`inline-${type}-3`}
                                                            checked={EdicaoCapacidade.transformar}
                                                            onChange={handleChangeCheckbox}
                                                        />
                                                    </div>
                                                ))}
                                            </Row>
                                        </>
                                    }
                                </Tab>
                            </Tabs>
                        </form>
                    </div>
                    <div className="footer-modal">
                        <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditar(false)}>Cancelar</button>
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={(e) => { e.preventDefault(); editarItensDemanda(e) }}>Salvar</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalEditarCapacidade